// utils/selectOptions.js

// Prepend a "select all" shortcut option only when it actually does something.
// With 0 or 1 real options the shortcut is a no-op, so it is omitted rather
// than rendered as a dead choice.
export const withSelectAllOption = (selectAllOption, options = []) =>
  options.length > 1 ? [selectAllOption, ...options] : [...options];
